import React, { FC, useState } from 'react';
import ResetPasswordIcon from '../../../../assets/images/svg/ResetPassowordIcon';
import { Button } from '../../../../shared/components/button';
import {
  CardContainer,
  CardIconHeader,
} from '../../../../shared/components/card';
import { TextInput } from '../../../../shared/components/inputs';
import { useNotificationCenter } from '../../../../shared/components/toast';
import { NavigationLink } from '../../../../shared/components/utility';
import { PasswordResetRequestDTO } from '../../infra/types/RequestPasswordReset.type';

interface ResetTemplateProps {
  onSubmit: (
    request: PasswordResetRequestDTO,
    cb: (error: string | null, success: boolean) => void,
  ) => Promise<void>;
  token: string;
}

const ResetTemplate: FC<ResetTemplateProps> = ({ onSubmit, token }) => {
  const { addNotification } = useNotificationCenter();
  const initialValue: PasswordResetRequestDTO = {
    email: '',
    token: token,
    password: '',
    confirm_password: '',
  };
  const [resetReq, setResetReq] = useState<PasswordResetRequestDTO>(
    initialValue,
  );

  const handleOnInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    if (name === 'token') return;
    const fixedValue = name === 'email' ? value.toLowerCase() : value;

    setResetReq({ ...resetReq, [name]: fixedValue });
  };

  const handleOnSubmitForm = async () => {
    await onSubmit(resetReq, (error, success) => {
      if (error && !success) {
        addNotification(
          {
            title: 'Error',
            description: error,
          },
          {
            variant: 'ERROR',
          },
        );
        return;
      }

      setResetReq({ ...initialValue, token: '' });
    });
  };

  return (
    <CardContainer
      className='w-full rounded-lg bg-white shadow'
      header={
        <CardIconHeader
          headerHeight='LARGE'
          icon={<ResetPasswordIcon />}
          title='Reset Your Password'
          subtitle='Use the following form to create a new password.'
        />
      }
    >
      <form autoComplete='off'>
        <TextInput
          classes={['mb-4']}
          label='Email Address'
          autoComplete='email-address'
          placeholder='Email Address'
          name='email'
          type='text'
          onChange={handleOnInputChange}
        />
        <TextInput
          classes={['mb-4']}
          label='New Password'
          placeholder='New Password'
          autoComplete='new-password'
          name='password'
          type='password'
          onChange={handleOnInputChange}
        />
        <TextInput
          classes={['mb-10']}
          label='Confirm Password'
          placeholder='Confirm Password'
          autoComplete='confirm-password'
          name='confirm_password'
          type='password'
          onChange={handleOnInputChange}
        />
        <Button
          classes={['mb-10']}
          label='Reset Password'
          theme='PRIMARY'
          type='button'
          onClick={handleOnSubmitForm}
        />
      </form>
      <div className='mb-4 flex flex-row items-center justify-center'>
        <NavigationLink dest='/' label='Back to Login' color='gray' />
      </div>
    </CardContainer>
  );
};

export default ResetTemplate;
